import e from "./HttpMethod.vue_vue_type_script_setup_true_lang.js";
//#region src/code-example/components/HttpMethod.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=HttpMethod.vue.js.map